// extracted by mini-css-extract-plugin
export var colorSquare = "_l9-0";
export var danger = "_l9-5";
export var lightPink = "_l9-8";
export var neutralBlue = "_l9-7";
export var neutralYellow = "_l9-6";
export var normal = "_l9-1";
export var primary = "_l9-2";
export var primaryLight = "_l9-3";
export var solidBlack = "_l9-g";
export var solidGreen = "_l9-b";
export var solidLightBlue = "_l9-d";
export var solidNavy = "_l9-c";
export var solidOrange = "_l9-f";
export var solidPink = "_l9-e";
export var solidRed = "_l9-9";
export var solidYellow = "_l9-a";
export var success = "_l9-4";